import { render, staticRenderFns } from "./AboutKECBody.vue?vue&type=template&id=3538e317&scoped=true&"
import script from "./AboutKECBody.vue?vue&type=script&lang=js&"
export * from "./AboutKECBody.vue?vue&type=script&lang=js&"
import style0 from "./AboutKECBody.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AboutKECBody.vue?vue&type=style&index=1&id=3538e317&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3538e317",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3538e317')) {
      api.createRecord('3538e317', component.options)
    } else {
      api.reload('3538e317', component.options)
    }
    module.hot.accept("./AboutKECBody.vue?vue&type=template&id=3538e317&scoped=true&", function () {
      api.rerender('3538e317', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/AboutUs/AboutKEC/AboutKECBody.vue"
export default component.exports